class SettingsStore {
	constructor() {
        this.settings = {
        	widgets: {},
        	trade: {}
        };
    }

    initialize() {
    	let settings = localStorage.getItem('userSettings');
    	if (!settings) return;
    	settings = JSON.parse(settings);

    	if (!settings.widgets) settings.widgets = {};
    	if (!settings.trade) settings.trade = {};
    	this.settings = settings;
    }

    getWidgetSettings(id) {
    	return this.settings.widgets[id];
    }

    updateWidgetSettings(wSettings) {
    	this.settings.widgets[wSettings.id] = wSettings;
    	this.saveSettings();
    }    

    saveSettings() {
    	//console.log('Saving settings: ' + JSON.stringify(this.settings));
    	localStorage.setItem('userSettings', JSON.stringify(this.settings));
    }
}

export let settingsStore = new SettingsStore();